<template>
  <div class="sound-element-wrapper" title="单击播放" @click="play">
    <a-icon type="play-circle" :spin="playing" style="margin-right:5px" />
    {{ second + '"' }}
  </div>
</template>

<script>
export default {
  name: "SoundElem",
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      amr: null,
      audio: null,
      playing: false
    };
  },
  computed: {
    url() {
      return this.payload.url || this.payload.Url;
    },
    size() {
      return this.payload.size || this.payload.Size;
    },
    second() {
      return this.payload.second || this.payload.Second;
    }
  },
  mounted() {
    const audio = document.createElement("audio");
    audio.src = this.url;
    this.audio = audio;
    audio.onended = () => {
      this.playing = false;
    };
  },
  methods: {
    play() {
      this.playing = true;
      if (this.audio.paused) {
        this.audio.play();
      } else {
        this.audio.pause();
        this.playing = false;
        this.audio.currentTime = 0;
      }
    },
    tryPlayAMR() {
      try {
        const isIE = /MSIE|Trident|Edge/.test(window.navigator.userAgent);
        // amr 播放组件库在 IE 不支持
        if (isIE) {
          this.$message.info(
            "您的浏览器不支持该格式的语音消息播放，请尝试更换浏览器，建议使用：谷歌浏览器"
          );
          return;
        }
        // 动态插入 amr 播放组件库
        if (!window.BenzAMRRecorder) {
          const script = document.createElement("script");
          script.addEventListener("load", this.playAMR);
          script.src = "./BenzAMRRecorder.js";
          const firstScript = document.getElementsByTagName("script")[0];
          firstScript.parentNode.insertBefore(script, firstScript);
          return;
        }
        this.playAMR();
      } catch (error) {
        this.$message.info(
          "您的浏览器不支持该格式的语音消息播放，请尝试更换浏览器，建议使用：谷歌浏览器"
        );
      }
    },
    playAMR() {
      if (!this.amr && window.BenzAMRRecorder) {
        this.amr = new window.BenzAMRRecorder();
      }
      if (this.amr.isInit()) {
        this.amr.play();
        return;
      }
      this.amr.initWithUrl(this.url).then(() => {
        this.amr.play();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.sound-element-wrapper {
  padding: 0px 10px;
  cursor: pointer;
}
</style>
